import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";
import { Field } from "../../../models/field.model";
import { FieldDataProvider } from "../../../data-provider/field.dp";
import { ResultDataProvider } from "../../../data-provider/result.dp";
import { DashboardDataProvider } from "../../../data-provider/dashboard.dp";
import html2canvas from "html2canvas";
import { ActivityFilter } from "../../../models/activity-filter.model";
import { ActivityDataProvider } from "../../../data-provider/activity.dp";
import { DashboardWidget } from "../../../models/dashboard-widget.model";
import { DashboardWidgetFilter } from "../../../models/dashboard-widget-filter.model";
import { Dashboard } from "../../../models/dashboard.model";
import { PermissionCheck } from "../../../shared/permission";
import { User } from "../../../models/user.model";
import { UserDataProvider } from "../../../data-provider/user.dp";
import { ToastUtils } from "../../../helper/toast.helper";
import { tableFields } from "../../../utils/constants/fields.constants";

let WidgetComponent = {
    selector: "vcWidget",
    templateUrl: "/angular/components/dashboard/widget/widget.component.html",
    bindings: {
        dashboard: "=",
        widget: "=",
        globalFilter: "=",
        downloading: "=",
        loading: "=",
        mode: "=?",
        closeFn: "&?",
    },
    controller: class WidgetController {
        // * bindings for typescript compiler *
        public dashboard: Dashboard;
        public widget: DashboardWidget;
        public globalFilter?: DashboardWidgetFilter;
        public downloading: boolean;
        public loading: boolean;
        public mode: string;
        // ************************************

        private readonly $scope: any;
        private readonly $rootScope: any;
        private readonly $timeout: any;
        private readonly $location: any;
        private readonly $filter: any;
        private dialog: DialogUtils;
        private customFields: any[];
        public showComponent: boolean = false;
        public componentInView: boolean = false;
        public dataProvider: DashboardDataProvider;
        public resultDataProvider: ResultDataProvider;
        public activityDataProvider: ActivityDataProvider;
        public activityFilter: ActivityFilter;
        public noFiltersNumber: number = 0;
        public activityUserId: string | number = null;
        public combinedFilter: DashboardWidgetFilter;
        public customTemplates: any;
        public permissionProvider: PermissionCheck;
        public user: User;
        public downloadTime: string;
        public preparingDownload: boolean;
        private toast: ToastUtils;
        public isLeaderView: boolean = true;

        constructor(
            $scope: any,
            $rootScope: any,
            $timeout: any,
            $location: any,
            $filter: any,
            __app_type: string,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            FieldDataProvider: FieldDataProvider,
            ActivityDataProvider: ActivityDataProvider,
            DashboardDataProvider: DashboardDataProvider,
            UserDataProvider: UserDataProvider,
            PermissionCheck: PermissionCheck,
            ResultDataProvider: ResultDataProvider
        ) {
            this.$scope = $scope;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.$timeout = $timeout;
            this.$filter = $filter;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.resultDataProvider = ResultDataProvider;
            this.activityDataProvider = ActivityDataProvider;
            this.dataProvider = DashboardDataProvider;
            this.combinedFilter = new DashboardWidgetFilter();
            this.permissionProvider = PermissionCheck;
            this.user = UserDataProvider.getActiveUser();
            this.isLeaderView = __app_type == "LEADER";
            FieldDataProvider.getCustomFields().then((customFields) => {
                this.customFields = customFields;
            });

            this.customTemplates =
                this.resultDataProvider.getCustomDateTemplates();

            this.$scope.$watch(
                () => this.widget.filter,
                (newValue, oldValue) => {
                    if (oldValue && newValue !== oldValue) {
                        this.setFilters();
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.globalFilter,
                (newValue, oldValue) => {
                    if (oldValue && newValue !== oldValue) {
                        this.setFilters();
                    }
                },
                true
            );
        }

        $onInit() {
            if (this.widget) {
                this.dataProvider.dedupeWidgetColumns(this.widget);
                if (this.widget.type == "activity") {
                    this.showComponent = true;
                } else {
                    this.setFilters();
                }

                this.widget.hasEditPermission =
                    this.dashboard.hasEditPermission ||
                    parseInt(this.user.uid) == this.widget.creator;

                if (this.dashboard.location == "user") {
                    this.activityUserId = this.globalFilter.users[0].uid;

                    if (this.widget.type == "activity") {
                        this.noFiltersNumber = 1;
                    }
                }

                this.$scope.$watch(
                    () => this.widget.type,
                    (newValue, oldValue) => {
                        if (newValue !== oldValue) {
                            if (this.widget.type == "activity") {
                                let filter: ActivityFilter = new ActivityFilter(
                                    this.widget.filter.dataTypeSpecificFilter
                                );
                                this.widget.filter.dataTypeSpecificFilter =
                                    filter;
                                this.activityFilter = new ActivityFilter(
                                    filter
                                );
                                this.showComponent = true;
                            }
                        }
                    },
                    true
                );
            }
        }

        openColumnsDialog(widget: DashboardWidget, ev: any): void {
            this.dataProvider.dedupeWidgetColumns(widget);
            this.dialog
                .show({
                    component: "vc-columns-dialog",
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    ariaLabel: "Choose which columns you see.",
                    class: "columns-dialog",
                    locals: {
                        columns: widget.style.tableOptions.columns,
                        sortable: true,
                    },
                })
                .then((columns: any) => {
                    widget.style.tableOptions.columns = columns;
                });
        }

        nowInView() {
            this.componentInView = true;
        }

        setFilters() {
            if (this.widget.type != "activity") {
                if (this.globalFilter) {
                    this.combinedFilter.setCombinedData(
                        this.widget.filter.combineWithGlobal(this.globalFilter)
                    );
                } else {
                    this.combinedFilter.setData(this.widget.filter);
                }
            }
        }

        numActiveSpecificFilters() {
            if (
                this.widget.filter &&
                this.widget.filter.dataTypeSpecificFilter &&
                this.widget.filter.dataTypeSpecificFilter.nonEmptyValues
            ) {
                return Object.keys(
                    this.widget.filter.dataTypeSpecificFilter.nonEmptyValues()
                ).length;
            }
            return 0;
        }

        otherActiveFilters() {
            if (this.widget.type == "activity") {
                // this.widget.fi;
            }
        }

        isDataChart(widgetType: string): boolean {
            return [
                "statuses",
                "rating",
                "age",
                "sex",
                "chart",
                "employment",
                "customField",
            ].includes(widgetType);
        }

        getFullOverviewLink(): string {
            let filterString = JSON.stringify(this.widget.filter);
            return "/#/results/efforts?filter=" + filterString;
        }

        isCustomFieldWidget(widget: any): boolean {
            return widget.cfid !== null;
        }

        changeChartType(chartType: string): void {
            this.widget.style.chartType = chartType;
            this.saveWidget();
        }

        saveWidget(): void {
            this.dataProvider.updateWidget(this.widget).then(() => {});
        }

        fieldFromWidget(widget): Field | null {
            let customField = null;
            angular.forEach(this.customFields, (field: Field) => {
                if (field.id == widget.cfid) {
                    customField = field;
                }
            });
            return customField;
        }

        edit(ev: any) {
            this.dialog
                .show({
                    component: "vc-create-widget",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Edit Report",
                    size: "xx-large",
                    fullscreen: true,
                    forceFullscreen: true,
                    locals: {
                        widget: angular.copy(this.widget),
                        globalFilter: this.globalFilter,
                        dashboard: this.dashboard,
                    },
                })
                .then((widget: any) => {
                    this.widget.setData(widget);
                    if (this.widget.type == "activity") {
                        this.showComponent = false;

                        this.$timeout(() => {
                            this.showComponent = true;
                        }, 100);
                    }
                });
        }

        openFullscreen(widget: DashboardWidget, dashboard: Dashboard, ev: any) {
            this.dialog
                .show({
                    component: "vc-fullscreen-widget",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    forceFullscreen: true,
                    ariaLabel: "Fullscreen Widget",
                    size: "xx-large",
                    locals: {
                        widget: widget,
                        dashboard: dashboard,
                    },
                })
                .then((widget: any) => {});
        }

        duplicate(ev: any) {
            this.dialog
                .show({
                    component: "vc-duplicate-widget",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Duplicate Report",
                    size: "large",
                    locals: {
                        widget: angular.copy(this.widget),
                    },
                })
                .then((widget: any) => {
                    this.$rootScope.$broadcast("widgetCreated", widget);
                });
        }

        delete(ev: any) {
            this.dialog
                .delete({
                    targetEvent: ev,
                    skipHide: true,
                    fullscreen: true,
                    locals: {
                        title: `Delete report?`,
                        bodyText:
                            "Are you sure you want to delete this report?",
                    },
                })
                .then(() => {
                    let data: DashboardWidget = angular.copy(this.widget);
                    this.dataProvider.deleteWidget(data).then(() => {
                        this.$rootScope.$broadcast("widgetDeleted", data);
                    });
                });
        }

        openFilterDialog(ev: any) {
            if (this.widget.type == "activity") {
                this.dialog
                    .show({
                        component: "vc-activity-filter",
                        targetEvent: ev,
                        scope: this.$scope,
                        locals: {
                            mode: null,
                            activeFilter:
                                this.widget.filter.dataTypeSpecificFilter,
                        },
                    })
                    .then((filter?: ActivityFilter) => {
                        this.saveWidget();
                    });
            } else {
                this.dialog
                    .show({
                        component: "vc-widget-filter-dialog",
                        targetEvent: ev,
                        scope: this.$scope,
                        clickOutsideToClose: false,
                        ariaLabel: "Widget Filter",
                        size: "large",
                        locals: {
                            widget: angular.copy(this.widget),
                            dashboard: this.dashboard,
                        },
                    })
                    .then((widget: any) => {
                        this.widget.setData(widget);
                    });
            }
        }

        downloadChart(ev: any): void {
            this.preparingDownload = true;
            this.downloading = true;
            this.downloadTime = this.nowDateTime();

            this.$timeout(() => {
                let fileNameStart: string = this.widget.name
                    .replace(/[^a-z0-9]/gi, "_")
                    .toLowerCase();
                let element: HTMLElement = document.getElementById(
                    "widget-" + this.widget.id
                );

                const now: Date = new Date();
                const nowString = this.$filter("date")(
                    now,
                    "yyyy_MM_dd_hh_mm_ss"
                );
                const filename: string =
                    fileNameStart + "_" + nowString + ".png";

                this.preparingDownload = false;
                this.downloading = false;
                this.downloadTime = null;

                html2canvas(element)
                    .then((canvas) => {
                        canvas.style.display = "none";
                        document.body.appendChild(canvas);
                        return canvas;
                    })
                    .then((canvas) => {
                        const image = canvas.toDataURL("image/png");
                        const a = document.createElement("a");
                        a.setAttribute("download", filename);
                        a.setAttribute("href", image);
                        a.click();
                        canvas.remove();
                    });
            }, 100);
        }

        nowDateTime() {
            const valueDate = new Date();

            let hours: string | number = valueDate.getHours();
            let minutes: string | number = valueDate.getMinutes();
            const ampm = hours >= 12 ? "PM" : "AM";
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            if (hours < 10) {
                hours = "0" + hours;
            }
            minutes = minutes < 10 ? "0" + minutes : minutes;
            let _date = this.$filter("date")(valueDate, "MMM dd");

            return _date + " - " + hours + ":" + minutes + " " + ampm;
        }

        getFieldName(id: string): string {
            let field: any;
            if (id.indexOf("customfield-") > -1) {
                let cfid = id.split("-")[1];
                if (this.customFields && this.customFields.length > 0) {
                    field = this.customFields.find(
                        (field: Field) => field.cfid === cfid
                    );
                }
            } else {
                field = tableFields.find((field: any) => field.id === id);
            }
            return field ? field.name : "";
        }

        confirm(): void {
            this.dialog.hide(this.widget);
        }

        cancel(): void {
            this.dialog.cancel();
        }

        exportTable(): void {
            this.resultDataProvider
                .dataTableExport(this.widget, this.combinedFilter)
                .then(
                    () => {
                        this.toast
                            .action("Export In Progress", "View Exports")
                            .then((value: string) => {
                                if (value == "ok") {
                                    this.$location.url(
                                        this.isLeaderView
                                            ? "/leader_exports"
                                            : "/exports"
                                    );
                                }
                            });
                    },
                    (error) => {
                        this.toast.error(error);
                    }
                );
        }

        /**
         * Gets the text to display in the filter pill
         */
        public getPermissionPillText(): string {
            const selectedIds: number[] =
                this.combinedFilter.permissionIds || [];
            const visiblePermissions: any =
                this.permissionProvider.levels.filter(
                    (permission: any) => permission.permissionid != 7
                );
            const selectedCount = selectedIds.length;

            // 1. If All Visible are selected, we return empty (pill will be hidden by ng-if)
            if (
                selectedCount === visiblePermissions.length ||
                selectedCount === 0
            ) {
                return "";
            }

            // 2. If 3 or fewer, list the names
            if (selectedCount <= 3) {
                return visiblePermissions
                    .filter((p) => selectedIds.includes(p.permissionid))
                    .map((p) => p.permissionname)
                    .join(", ");
            }

            // 3. Otherwise, show the count
            return `${selectedCount} Permissions`;
        }

        /**
         * Determines if the pill should be shown
         */
        public showPermissionPill(): boolean {
            const text = this.getPermissionPillText();
            // Show only if there is text and it's not the "All" state
            return text.length > 0;
        }
    },
};

angular
    .module("dashboard")
    .component(WidgetComponent.selector, WidgetComponent);
